import React, { useEffect, useState } from 'react';
import { Grid, Paper, Typography, CircularProgress } from '@mui/material';
import { Bar, Pie, Doughnut } from 'react-chartjs-2';
import api from '../service/Api';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

function Graficos() {
    const [processosPorArea, setProcessosPorArea] = useState({});
    const [dadosSensiveisCount, setDadosSensiveisCount] = useState({ true: 0, false: 0 });
    const [dadosSensiveisMenorCount, setDadosSensiveisMenorCount] = useState({ true: 0, false: 0 });
    const [compartilhamentoExternoCount, setCompartilhamentoExternoCount] = useState({ true: 0, false: 0 });
    const [riscoCount, setRiscoCount] = useState({ Baixo: 0, Medio: 0, Alto: 0 });
    const [acoesPorArea, setAcoesPorArea] = useState({});
    const [selectedArea, setSelectedArea] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const areasResponse = await api.get('api/areas');
                const processosResponse = await api.get('api/processos');
                const areas = areasResponse.data;
                const processos = processosResponse.data;

                const areaProcessCount = areas.reduce((acc, area) => {
                    acc[area.nome] = 0;
                    return acc;
                }, {});

                let sensitiveCount = { true: 0, false: 0 };
                let sensitiveMenorCount = { true: 0, false: 0 };
                let externoCount = { true: 0, false: 0 };
                let riscoCount = { Baixo: 0, Medio: 0, Alto: 0 };
                let acoesPorArea = areas.reduce((acc, area) => {
                    acc[area.nome] = {};
                    return acc;
                }, {});

                processos.forEach(processo => {
                    if (processo.dados_sensiveis === 1) {
                        sensitiveCount.true += 1;
                    } else {
                        sensitiveCount.false += 1;
                    }

                    if (processo.dados_menor_sensiveis === 1) {
                        sensitiveMenorCount.true += 1;
                    } else {
                        sensitiveMenorCount.false += 1;
                    }

                    if (processo.compartilhamento_externo === 1) {
                        externoCount.true += 1;
                    } else {
                        externoCount.false += 1;
                    }

                    if (processo.areas_selecionadas_nome) {
                        processo.areas_selecionadas_nome.split(', ').forEach(areaNome => {
                            if (areaProcessCount[areaNome] !== undefined) {
                                areaProcessCount[areaNome] += 1;
                            }
                        });
                    }

                    if (processo.classificacao_riscos === 'Baixo') {
                        riscoCount.Baixo += 1;
                    } else if (processo.classificacao_riscos === 'Medio') {
                        riscoCount.Medio += 1;
                    } else if (processo.classificacao_riscos === 'Alto') {
                        riscoCount.Alto += 1;
                    }

                    if (processo.acoes && processo.areas_selecionadas_nome) {
                        processo.areas_selecionadas_nome.split(', ').forEach(areaNome => {
                            if (acoesPorArea[areaNome]) {
                                processo.acoes.split(', ').forEach(acao => {
                                    if (acoesPorArea[areaNome][acao]) {
                                        acoesPorArea[areaNome][acao] = 1;
                                    } else {
                                        acoesPorArea[areaNome][acao] = 1;
                                    }
                                });
                            }
                        });
                    }
                });

                setProcessosPorArea(areaProcessCount);
                setDadosSensiveisCount(sensitiveCount);
                setDadosSensiveisMenorCount(sensitiveMenorCount);
                setCompartilhamentoExternoCount(externoCount);
                setRiscoCount(riscoCount);
                setAcoesPorArea(acoesPorArea);
            } catch (error) {
                console.error('Erro ao buscar dados: ', error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);


    const barData = {
        labels: Object.keys(processosPorArea),
        datasets: [
            {
                label: 'Número de Processos',
                data: Object.values(processosPorArea),
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
        ],
    };

    const pieData = {
        labels: ['Dados Sensíveis', 'Não lida com Sensíveis'],
        datasets: [
            {
                data: [dadosSensiveisCount.true, dadosSensiveisCount.false],
                backgroundColor: ['rgba(255, 99, 132, 0.6)', 'rgba(54, 162, 235, 0.6)'],
                borderColor: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)'],
                borderWidth: 1,
            },
        ],
    };

    const pieMenorData = {
        labels: ['Dados Sensíveis Menores', 'Não lida com Sensíveis Menores'],
        datasets: [
            {
                data: [dadosSensiveisMenorCount.true, dadosSensiveisMenorCount.false],
                backgroundColor: ['rgba(255, 159, 64, 0.6)', 'rgba(153, 102, 255, 0.6)'],
                borderColor: ['rgba(255, 159, 64, 1)', 'rgba(153, 102, 255, 1)'],
                borderWidth: 1,
            },
        ],
    };

    const doughnutData = {
        labels: ['Compartilhamento Externo', 'Sem Compartilhamento Externo'],
        datasets: [
            {
                data: [compartilhamentoExternoCount.true, compartilhamentoExternoCount.false],
                backgroundColor: ['rgba(75, 192, 192, 0.6)', 'rgba(255, 206, 86, 0.6)'],
                borderColor: ['rgba(75, 192, 192, 1)', 'rgba(255, 206, 86, 1)'],
                borderWidth: 1,
            },
        ],
    };

    const barOptions = {
        responsive: true,
        scales: {
            y: {
                beginAtZero: true,
                max: 20,
                ticks: {
                    precision: 0
                }
            },
        },
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Número de Processos por Área',
            },
        },
        maintainAspectRatio: false
    };

    const pieOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Distribuição de Dados Sensíveis nos Processos',
            },
        },
        maintainAspectRatio: false
    };

    const pieMenorOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Distribuição de Dados Sensíveis Menores nos Processos',
            },
        },
        maintainAspectRatio: false
    };

    const doughnutOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Distribuição de Compartilhamento Externo nos Processos',
            },
        },
        maintainAspectRatio: false
    };

    const riscoData = {
        labels: ['Baixo', 'Médio', 'Alto'],
        datasets: [
            {
                label: 'Número de Processos',
                data: [riscoCount.Baixo, riscoCount.Medio, riscoCount.Alto],
                backgroundColor: ['rgba(75, 192, 192, 0.6)', 'rgba(255, 206, 86, 0.6)', 'rgba(255, 99, 132, 0.6)'],
                borderColor: ['rgba(75, 192, 192, 1)', 'rgba(255, 206, 86, 1)', 'rgba(255, 99, 132, 1)'],
                borderWidth: 1,
            },
        ],
    };

    const riscoOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Distribuição de Processos por Nível de Risco',
            },
        },
        maintainAspectRatio: false
    };

    const pieData2 = {
        labels: Object.keys(acoesPorArea),
        datasets: [
            {
                data: Object.keys(acoesPorArea).map(area => {
                    return Object.values(acoesPorArea[area]).reduce((sum, count) => sum + count, 0);
                }),
                backgroundColor: [
                    'rgba(255, 99, 132, 0.6)',
                    'rgba(75, 192, 192, 0.6)',
                    'rgba(255, 205, 86, 0.6)',
                    'rgba(54, 162, 235, 0.6)',
                    'rgba(153, 102, 255, 0.6)',
                    'rgba(255, 159, 64, 0.6)',
                    'rgba(0, 128, 0, 0.6)',
                    'rgba(128, 0, 128, 0.6)',
                    'rgba(255, 0, 0, 0.6)',
                    'rgba(0, 0, 255, 0.6)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(255, 205, 86, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)',
                    'rgba(0, 128, 0, 1)',
                    'rgba(128, 0, 128, 1)',
                    'rgba(255, 0, 0, 1)',
                    'rgba(0, 0, 255, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };

    const pieOptions2 = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Distribuição das Ações por Área',
            },
        },
        maintainAspectRatio: false,
        onClick: (evt, element) => {
            if (element.length > 0) {
                const index = element[0].index;
                const area = pieData2.labels[index];
                setSelectedArea(area);
            }
        },
    };


    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
                <CircularProgress />
            </Grid>
        );
    }

    if (error) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
                <Typography color="error">Error: {error}</Typography>
            </Grid>
        );
    }

    return (
        <Grid container spacing={2} style={{ marginTop: '1%' }}>
            <Grid item xs={12} md={4}>
                <Paper elevation={5} style={{ padding: '20px', borderRadius: '35px' }}>
                    <Typography variant="h6" align="center">Distribuição de Dados Sensíveis</Typography>
                    <div style={{ width: '100%', height: '400px' }}>
                        <Pie data={pieData} options={pieOptions} />
                    </div>
                </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
                <Paper elevation={5} style={{ padding: '20px', borderRadius: '35px' }}>
                    <Typography variant="h6" align="center">Distribuição de Dados Sensíveis Menores</Typography>
                    <div style={{ width: '100%', height: '400px' }}>
                        <Pie data={pieMenorData} options={pieMenorOptions} />
                    </div>
                </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
                <Paper elevation={5} style={{ padding: '20px', borderRadius: '35px' }}>
                    <Typography variant="h6" align="center">Distribuição de Compartilhamento Externo</Typography>
                    <div style={{ width: '100%', height: '400px' }}>
                        <Doughnut data={doughnutData} options={doughnutOptions} />
                    </div>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Paper elevation={5} style={{ padding: '20px', borderRadius: '35px' }}>
                    <Typography variant="h6" align="center">Número de Processos por Área</Typography>
                    <div style={{ width: '100%', height: '500px' }}>
                        <Bar data={barData} options={barOptions} />
                    </div>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Paper elevation={5} style={{ padding: '20px', borderRadius: '35px' }}>
                    <Typography variant="h6" align="center">Distribuição de Processos por Nível de Risco</Typography>
                    <div style={{ width: '100%', height: '500px' }}>
                        <Bar data={riscoData} options={riscoOptions} />
                    </div>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Paper elevation={5} style={{ padding: '20px', borderRadius: '35px', marginBottom: '3%' }}>
                    <Typography variant="h6" align="center">Distribuição das Ações por Área</Typography>
                    <div style={{ width: '100%', height: '500px' }}>
                        <Pie data={pieData2} options={pieOptions2} style={{ cursor: 'pointer' }} />
                    </div>
                    {selectedArea && (
                        <div style={{ marginTop: '20px' }}>
                            <Typography variant="h6" align="center">{`Ações para ${selectedArea}`}</Typography>
                            <ul>
                                {Object.entries(acoesPorArea[selectedArea]).map(([acao], index) => (
                                    acao !== '--' ? <li key={index}> {acao}</li> : ''
                                ))}
                            </ul>
                        </div>
                    )}
                </Paper>
            </Grid>
        </Grid>
    );
}

export default Graficos;
